<template>
    <CTable
        v-if="data.page"
        :isLoading="isLoading"
        v-model:columns="data.columns"
        v-model:page="data.page"
        :options="data.tableOptions"
        :manages="data.manages"
        :manageExtras="data.manageExtras"
        :rowActions="data.rowActions"
        :clientSide="true"
        :canRefresh="false"
    ></CTable>
</template>

<script>
import { defineComponent, defineAsyncComponent, reactive } from "vue";
import { isLoading, initData } from "./role-resource-tab-list.logic";
import { matchMenu } from "../../../../../utils/menu-context";
import { state as stateApp } from "../../../../../app.logic";

export default defineComponent({
    components: {
        CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable")),
    },
    props: {
        menuContext: { default: () => matchMenu("/app/setting/user-mgt/role-resources", stateApp.authInfo.menus) },
        viewOnly: {},
        useForm: {},
        parent: {},
        fetchCriteria: {},
        visibleRole: { default: true },
        visibleResource: { default: true },
    },
    setup(props) {
        const data = reactive({});
        const refs = reactive({});
        initData({ props, data, refs });
        return { props, data, refs, isLoading };
    },
});
</script>